
var Model = require("../types/Model.js");

var SCREENSAVER_TIMER = 15 * 60 * 1000; // 15 minutes before screensaver

module.exports = new Model({
	name: "screensaver",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,
	show: show,
	clear: clear,

	_timer: null,
	_isCalling: false,
	_isReminding: false,
	_type: "time",
});

function init() {
	this._timer = setInterval(show.bind(this), SCREENSAVER_TIMER);
	this.push(null);
}

function uninit() {
	clearInterval(this._timer);
}

function triggers() {
	return {
		clear: clear
	};
}

function listeners() {
	return {
		"atouchawaysettings:updated": handle_settings_update,
		"calling:updated": handle_calling_update,
		"activereminder:active": handle_visible_reminders,
		"activereminder:hidden": handle_hidden_reminders,
		"activeworkflowaction:viewing": handle_visible_workflow,
		"activeworkflowaction:finish": handle_hidden_workflow,
		"latest messages:new": clear
	};
}

function handle_calling_update(data){
	if(data.state !== "idle"){
		this.clear();
		this._isCalling = true;
	}else{
		this._isCalling = false;
	}
}

function handle_settings_update(settings) {
	this._type = settings.screensaver || "time";
}

function show(){
	if(this._isCalling || this._isReminding || this._isWorkflowing) return;
	this.push(this._type);
}

function handle_visible_reminders() {
	this.clear();
	this._isReminding = true;
}

function handle_hidden_reminders() {
	this._isReminding = false;
}

function handle_visible_workflow(){
	this.clear();
	this._isWorkflowing = true;
}

function handle_hidden_workflow(){
	this._isWorkflowing = false;
}

function clear() {
	if(this.data) {
		this.emit("usermetrics:trigger:track", "clear atouchaway screensaver");
		this.push(null);
	}
}
